import * as $ from "jquery";
import { template } from 'lodash';

type SearchResult = { pageKey: any; title: any; description: any; flag: string; };
type SearchPage = { dom: any; meta: { title: string; description: any; }; flags: { isTutorial: any; }; };

export default class Search {
  searchData: any;

  constructor(searchData: any) {
    this.searchData = searchData || {};
    this.bindEvents();
  }

  bindEvents() {
    var self = this;

    $(document).on("propertychange change click keyup input paste", ".search-page #search-wrap input", function () {
      var term = $(this).val() as string;
      if (term.length > 2) {
        self.runSearch(term);
      }
    });
  }

  runSearch(term: string) {
    var searchResults: SearchResult[] = [];

    this.searchData.forEach(function (page: SearchPage, pageKey: any) {
      var html = JSON.stringify(page.dom);
      if (html.indexOf(term) > -1) {
        var searchItem = {
          "pageKey": pageKey,
          "title": page.meta.title.replace("| Atlassian Git Tutorial", ""),
          "description": page.meta.description,
          "flag": page.flags.isTutorial ? "tutorial" : "articles"
        };

        searchResults.push(searchItem);
      }
    });

    searchResults.sort(this.sortByType);

    this.renderSearchResults(searchResults);
  }

  sortByType(left: { flag: string; }) {
    return left.flag === "tutorial" ? -1 : 1;
  }

  renderSearchResults(items: SearchResult[]) {
    var itemTemplate = this.getItemTemplate();

    var contentTemplate = template(itemTemplate);
    $(".search-results-col").html(contentTemplate({ items: items }));
  }

  getItemTemplate() {
    return '\
  <div class="search-result-list">\
  <% items.forEach(function( item ){ %>\
    <div class="_item" >\
      <a href="/<%= item.pageKey %>">\
        <div>\
          <div class="_flag -<%= item.flag %>">\
            <h4><%= item.flag %></h4>\
          </div>\
          <h3 class="_title"><%= item.title %></h3>\
          <div class="_content">\
            <%= item.description %>\
          </div>\
        </div>\
      </a>\
    </div>\
  <% }); %>\
  </div>';
  }
}
